import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { toast } = useToast();
  
  const languages = [
    { code: "es", name: "Español" },
    { code: "en", name: "English" }
  ];

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    toast({
      title: t('footer.changed'),
      description: t('footer.changedDescription'),
    });
  };

  return (
    <footer className="w-full border-t mt-8 bg-[#FFDEE2]">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold mb-4">{t("footer.about")}</h3>
            <ul className="space-y-2">
              <li>{t("footer.aboutUs")}</li>
              <li>{t("footer.contact")}</li>
              <li>{t("footer.careers")}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.legal")}</h3>
            <ul className="space-y-2">
              <li>{t("footer.privacy")}</li>
              <li>{t("footer.terms")}</li>
              <li>{t("footer.cookies")}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.social")}</h3>
            <ul className="space-y-2">
              <li>Instagram</li>
              <li>Twitter</li>
              <li>Facebook</li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-4">{t("footer.language")}</h3>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="w-full">
                  <Globe className="mr-2 h-4 w-4" />
                  {languages.find(lang => lang.code === i18n.language)?.name || t("footer.language")}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-[200px]">
                {languages.map((lang) => (
                  <DropdownMenuItem
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className="cursor-pointer"
                  >
                    {lang.name}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
        <div className="mt-8 text-center text-sm text-gray-500">
          © 2024 {t('common.appName')}. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;